import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loadingio-spinner-eclipse-uw6pfcwqwl8">
        <div className="ldio-rwxris4t0zo">
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
